export const ALL_COLUMNS = [
  {
    value: "Customer Name",
    labelKey: "name",
  },
  {
    value: "Contact Number",
    labelKey: "contact",
  },
  {
    value: "Session Name",
    labelKey: "sessionName",
  },
  {
    value: "Sport Name",
    labelKey: "sportName",
  },
  {
    value: "Enrolled Sessions",
    labelKey: "noOfSessionToAttend",
  },
  {
    value: "Remaining Session",
    labelKey: "remainingSessions",
  },
  {
    value: "Session Days",
    labelKey: "days",
  },
  {
    value: "Start Date",
    labelKey: "startDate",
  },
  {
    value: "End Date",
    labelKey: "endDate",
  },
  {
    value: "Amount",
    labelKey: "totalAmount",
  },
  {
    value: "Payment Status",
    labelKey: "paymentStatus",
  },
  {
    value: "Session Booking Status",
    labelKey: "bookingStatus",
  },
  {
    value: "Coach Name",
    labelKey: "coachName",
  },
];

export const initialColumns = [
  {
    Header: "Customer Name",
    accessor: "name",
  },
  {
    Header: "Contact Number",
    accessor: "contact",
  },
  {
    Header: "Session Name",
    accessor: "sessionName",
  },
  {
    Header: "Sport Name",
    accessor: "sportName",
  },
  {
    Header: "Session Per Week",
    accessor: "noOfDays",
  },
  {
    Header: "Enrolled Sessions",
    accessor: "noOfSessionToAttend",
  },
  {
    Header: "Remaining Session",
    accessor: "remainingSessions",
  },
  {
    Header: "Session Days",
    accessor: "days",
  },
  {
    Header: "Start Date",
    accessor: "startDate",
  },
  {
    Header: "End Date",
    accessor: "endDate",
  },
  {
    Header: "Amount",
    accessor: "totalAmount",
  },
  {
    Header: "Payment Status",
    accessor: "paymentStatus",
  },
  {
    Header: "Session Booking Status",
    accessor: "bookingStatus",
  },
  {
    Header: "Coach Name",
    accessor: "coachName",
  },
];
